// Privacy-friendly analytics by Plausible.
// Injected into <head> at startup because this project has no editable
// index.html. Equivalent to the snippet provided by Plausible.

type PlausibleFn = ((...args: unknown[]) => void) & {
  q?: unknown[][]
  o?: Record<string, unknown>
  init?: (options?: Record<string, unknown>) => void
}

declare global {
  interface Window {
    plausible?: PlausibleFn
  }
}

const SCRIPT_SRC = 'https://plausible.io/js/pa-eUbweeSiC10CgVRqsuKs1.js'

export function initAnalytics() {
  if (typeof window === 'undefined') return
  if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return

  const script = document.createElement('script')
  script.async = true
  script.src = SCRIPT_SRC
  document.head.appendChild(script)

  const plausible: PlausibleFn =
    window.plausible ||
    ((...args: unknown[]) => {
      ;(plausible.q = plausible.q || []).push(args)
    })
  plausible.init =
    plausible.init ||
    ((options?: Record<string, unknown>) => {
      plausible.o = options || {}
    })
  window.plausible = plausible
  // Site uses hash URLs (/#/services), so count each hash change as a page.
  plausible.init({ hashBasedRouting: true })
}
